// DOM Content Loaded
document.addEventListener("DOMContentLoaded", function () {

    /**
     * Select elements in the DOM
     */

    const mobileNavTriggers = document.querySelectorAll('.js-toggle-nav');
    const mobileNavLinks = document.querySelectorAll('.nav__link');

    /**
     * Select all burger elements
     */

    for (const mobileNavTrigger of mobileNavTriggers) {
        mobileNavTrigger.addEventListener('click', (e) => {
            e.preventDefault();
            mobileNavToggle();
        });
    }

    for (const link of mobileNavLinks) {
        link.addEventListener('click', () => {
            if (document.body.classList.contains('nav-is-open')) {
                mobileNavToggle();
            }
        });
    }

    /**
     * Toggle open class
     */

    const mobileNavToggle = () => {
        document.body.classList.toggle('nav-is-open');
    };

});
